import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { LicenseInfoDto, LicenseWizardRequestDto, LicenseWizardResultDto, SoftwareInfoDto } from 'UvExplorerServer.Dtos.TS/LicenseStats';
import { LicensingWebService } from './licensing.web.service';

@Injectable()
export class LicensingService implements OnDestroy {

	public licenseInfo: LicenseInfoDto;

	private licenseInfoUpdated: Subject<any>;
	public onLicenseInfoUpdated: Observable<any>;

	constructor(private licWebService: LicensingWebService) {
		this.licenseInfo = undefined;

		// License info was updated from the server
		this.licenseInfoUpdated = new Subject<LicenseInfoDto>();
		this.onLicenseInfoUpdated = this.licenseInfoUpdated.asObservable();

		//this.getLicenseInfo();
	}

	public get hasLicenseInfo(): boolean {
		return !!this.licenseInfo;
	}

	public get isActivated(): boolean {
		return this.hasLicenseInfo ? this.licenseInfo.isActivated : false;
	}

	public get isLicenseValid(): boolean {
		return this.hasLicenseInfo ? this.licenseInfo.isLicenseValid : false;
	}

	public get isInGracePeriod(): boolean {
		return this.hasLicenseInfo && this.licenseInfo.isInGracePeriod;
	}

	get licenseExpires(){
		if(!this.licenseInfo){
			return new Date();
		}
		return this.licenseInfo.licenseExpires;
	}

	get gracePeriodRemaining(){
		if(!this.licenseInfo){
			return 0;
		}
		return this.licenseInfo.gracePeriodRemaining;
	}

	public ngOnDestroy(): void {
		return;
	}

	public testPrtgService(): Observable<any> {
		return this.licWebService.testPrtgService();
	}

	public getLicenseInfo(): Observable<LicenseInfoDto> {
		let subject = new Subject<LicenseInfoDto>();
		
		this.licWebService.getLicenseInfo().subscribe(
			(result: LicenseInfoDto) => {

				this.licenseInfo = result;
				subject.next(result);
				this.licenseInfoUpdated.next(result);
			},
			(error?: any) => {
				console.log(JSON.stringify(error));
				subject.error(error);
			});

		return subject.asObservable();
	}

	public getSoftwareUpdateInfo(): Observable<SoftwareInfoDto> {
		return this.licWebService.getSoftwareInfo();
	}

	public licenseActivationWizard(request: LicenseWizardRequestDto): Observable<LicenseWizardResultDto> {
		return this.licWebService.licenseActivationWizard(request);
	}

	public licenseDeactivationWizard(request: LicenseWizardRequestDto): Observable<LicenseWizardResultDto> {
		return this.licWebService.licenseDeactivationWizard(request);
	}

	public licenseUpdateWizard(request: LicenseWizardRequestDto): Observable<LicenseWizardResultDto> {
		return this.licWebService.licenseUpdateWizard(request);
	}

}